import Nullstack from 'nullstack';
export default function IconMultiplier05x({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-multiplier-0-5x",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 16h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), "   ", Nullstack.element("path", {
    d: "M5 16v.01"
  }), "   ", Nullstack.element("path", {
    d: "M15 16l4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M19 16l-4 -4"
  }), " ");
}